var _metadata, _defs, _g, _mask, _g2, _mask2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaseball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    width: 70,
    height: 70,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    className: "style-fonts"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.24410831171008 18.366938150664737) rotate(330.3191041377807 3.116851019673504 20.992032029265317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.12 3.52, 6.83 14.12, 6.74 21.12 C6.66 28.12, 0.7 38.51, -0.51 41.98 M0 0 C1.12 3.52, 6.83 14.12, 6.74 21.12 C6.66 28.12, 0.7 38.51, -0.51 41.98",
    stroke: "#005e79",
    strokeWidth: 4,
    fill: "none"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.31530476166927 9.29938971086898) rotate(147.35155827460682 3.116851019673504 20.992032029265346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.12 3.52, 6.83 14.12, 6.74 21.12 C6.66 28.12, 0.7 38.51, -0.51 41.98 M0 0 C1.12 3.52, 6.83 14.12, 6.74 21.12 C6.66 28.12, 0.7 38.51, -0.51 41.98",
    stroke: "#005e79",
    strokeWidth: 4,
    fill: "none"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(10 10) rotate(353.02342912349667 25 25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 25 C50 26.45, 49.87 27.92, 49.62 29.34 C49.37 30.77, 48.99 32.19, 48.49 33.55 C48 34.91, 47.37 36.25, 46.65 37.5 C45.93 38.75, 45.08 39.96, 44.15 41.07 C43.22 42.18, 42.18 43.22, 41.07 44.15 C39.96 45.08, 38.75 45.93, 37.5 46.65 C36.25 47.37, 34.91 48, 33.55 48.49 C32.19 48.99, 30.77 49.37, 29.34 49.62 C27.92 49.87, 26.45 50, 25 50 C23.55 50, 22.08 49.87, 20.66 49.62 C19.23 49.37, 17.81 48.99, 16.45 48.49 C15.09 48, 13.75 47.37, 12.5 46.65 C11.25 45.93, 10.04 45.08, 8.93 44.15 C7.82 43.22, 6.78 42.18, 5.85 41.07 C4.92 39.96, 4.07 38.75, 3.35 37.5 C2.63 36.25, 2 34.91, 1.51 33.55 C1.01 32.19, 0.63 30.77, 0.38 29.34 C0.13 27.92, 0 26.45, 0 25 C0 23.55, 0.13 22.08, 0.38 20.66 C0.63 19.23, 1.01 17.81, 1.51 16.45 C2 15.09, 2.63 13.75, 3.35 12.5 C4.07 11.25, 4.92 10.04, 5.85 8.93 C6.78 7.82, 7.82 6.78, 8.93 5.85 C10.04 4.92, 11.25 4.07, 12.5 3.35 C13.75 2.63, 15.09 2, 16.45 1.51 C17.81 1.01, 19.23 0.63, 20.66 0.38 C22.08 0.13, 23.55 0, 25 0 C26.45 0, 27.92 0.13, 29.34 0.38 C30.77 0.63, 32.19 1.01, 33.55 1.51 C34.91 2, 36.25 2.63, 37.5 3.35 C38.75 4.07, 39.96 4.92, 41.07 5.85 C42.18 6.78, 43.22 7.82, 44.15 8.93 C45.08 10.04, 45.93 11.25, 46.65 12.5 C47.37 13.75, 48 15.09, 48.49 16.45 C48.99 17.81, 49.37 19.23, 49.62 20.66 C49.87 22.08, 49.94 24.28, 50 25 C50.06 25.72, 50.06 24.28, 50 25",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseball);
export default __webpack_public_path__ + "static/media/baseball.7f7bc5a451cce7c3fa3adf8d52ad8a4f.svg";
export { ForwardRef as ReactComponent };